import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialWebsiteByTrialId: ITrialWebsiteLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALWEBSITE_LOAD_BY_TRIAL_ID,
            trialId
        }
    },
    LoadTrialWebsiteById: ITrialWebsiteLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALWEBSITE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialWebsiteLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialWebsiteLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialWebsite: ITrialWebsiteSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALWEBSITE_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialWebsiteSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialWebsiteSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialWebsite: ITrialWebsiteValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALWEBSITE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialWebsiteValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialWebsiteValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialWebsite: ITrialWebsiteCreateActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALWEBSITE_CREATE,
            trialId
        }
    },
    CreateSuccess: ITrialWebsiteCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALWEBSITE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialWebsiteCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialWebsite: ITrialWebsiteSyncActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALWEBSITE_SYNC,
            trialId
        }
    },
    SyncSuccess: ITrialWebsiteSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialWebsiteSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALWEBSITE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialWebsiteClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALWEBSITE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialWebsiteFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALWEBSITE_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALWEBSITE_LOAD_BY_TRIAL_ID = "ACTION_TRIALWEBSITE_LOAD_BY_TRIAL_ID",
    ACTION_TRIALWEBSITE_LOAD_BY_ID = "ACTION_TRIALWEBSITE_LOAD_BY_ID",
    ACTION_TRIALWEBSITE_LOAD_SUCCESS = "ACTION_TRIALWEBSITE_LOAD_SUCCESS",
    ACTION_TRIALWEBSITE_LOAD_FAILURE = "ACTION_TRIALWEBSITE_LOAD_FAILURE",

    ACTION_TRIALWEBSITE_SAVE = "ACTION_TRIALWEBSITE_SAVE",
    ACTION_TRIALWEBSITE_SAVE_SUCCESS = "ACTION_TRIALWEBSITE_SAVE_SUCCESS",
    ACTION_TRIALWEBSITE_SAVE_FAILURE = "ACTION_TRIALWEBSITE_SAVE_FAILURE",

    ACTION_TRIALWEBSITE_VALIDATE = "ACTION_TRIALWEBSITE_VALIDATE",
    ACTION_TRIALWEBSITE_VALIDATE_SUCCESS = "ACTION_TRIALWEBSITE_VALIDATE_SUCCESS",
    ACTION_TRIALWEBSITE_VALIDATE_FAILURE = "ACTION_TRIALWEBSITE_VALIDATE_FAILURE",

    ACTION_TRIALWEBSITE_CREATE = "ACTION_TRIALWEBSITE_CREATE",
    ACTION_TRIALWEBSITE_CREATE_SUCCESS = "ACTION_TRIALWEBSITE_CREATE_SUCCESS",
    ACTION_TRIALWEBSITE_CREATE_FAILURE = "ACTION_TRIALWEBSITE_CREATE_FAILURE",

    ACTION_TRIALWEBSITE_SYNC = "ACTION_TRIALWEBSITE_SYNC",
    ACTION_TRIALWEBSITE_SYNC_SUCCESS = "ACTION_TRIALWEBSITE_SYNC_SUCCESS",
    ACTION_TRIALWEBSITE_SYNC_FAILURE = "ACTION_TRIALWEBSITE_SYNC_FAILURE",

    ACTION_TRIALWEBSITE_CLEAR = "ACTION_TRIALWEBSITE_CLEAR",

    ACTION_TRIALWEBSITE_FILTER = "ACTION_TRIALWEBSITE_FILTER";

export interface ITrialWebsiteLoadByTrialIdAction {
    type: "ACTION_TRIALWEBSITE_LOAD_BY_TRIAL_ID";
    trialId: number;
}

export interface ITrialWebsiteLoadByTrialIdActionCreator {
    (trialId: number): ITrialWebsiteLoadByTrialIdAction;
}

export interface ITrialWebsiteLoadSuccessAction {
    type: "ACTION_TRIALWEBSITE_LOAD_SUCCESS";
    formData: Dtos.TrialWebsite | Dtos.TrialWebsite[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialWebsiteLoadSuccessActionCreator {
    (
        formData: Dtos.TrialWebsite | Dtos.TrialWebsite[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialWebsiteLoadSuccessAction;
}

export interface ITrialWebsiteLoadFailureAction {
    type: "ACTION_TRIALWEBSITE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialWebsiteLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialWebsiteLoadFailureAction;
}

export interface ITrialWebsiteLoadByIdAction {
    type: "ACTION_TRIALWEBSITE_LOAD_BY_ID";
    id: number;
}

export interface ITrialWebsiteLoadByIdActionCreator {
    (id: number): ITrialWebsiteLoadByIdAction;
}

export interface ITrialWebsiteSaveAction {
    type: "ACTION_TRIALWEBSITE_SAVE";
    formData: Dtos.TrialWebsite;

}

export interface ITrialWebsiteSaveActionCreator {
    (
        formData: Dtos.TrialWebsite
    ): ITrialWebsiteSaveAction;
}

export interface ITrialWebsiteSaveSuccessAction {
    type: "ACTION_TRIALWEBSITE_SAVE_SUCCESS";
    formData: Dtos.TrialWebsite;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialWebsiteSaveSuccessActionCreator {
    (
        formData: Dtos.TrialWebsite,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialWebsiteSaveSuccessAction;
}

export interface ITrialWebsiteSaveFailureAction {
    type: "ACTION_TRIALWEBSITE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialWebsiteSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialWebsiteSaveFailureAction;
}

export interface ITrialWebsiteValidateAction {
    type: "ACTION_TRIALWEBSITE_VALIDATE";
    formData: Dtos.TrialWebsite;

}

export interface ITrialWebsiteValidateActionCreator {
    (
        formData: Dtos.TrialWebsite
    ): ITrialWebsiteValidateAction;
}

export interface ITrialWebsiteValidateSuccessAction {
    type: "ACTION_TRIALWEBSITE_VALIDATE_SUCCESS";
    formData: Dtos.TrialWebsite;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialWebsiteValidateSuccessActionCreator {
    (
        formData: Dtos.TrialWebsite,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialWebsiteValidateSuccessAction;
}

export interface ITrialWebsiteValidateFailureAction {
    type: "ACTION_TRIALWEBSITE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialWebsiteValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialWebsiteValidateFailureAction;
}

export interface ITrialWebsiteCreateAction {
    type: "ACTION_TRIALWEBSITE_CREATE",
    trialId: number
}

export interface ITrialWebsiteCreateActionCreator {
    (trialId: number): ITrialWebsiteCreateAction
}

export interface ITrialWebsiteCreateSuccessAction {
    type: "ACTION_TRIALWEBSITE_CREATE_SUCCESS";
    formData: Dtos.TrialWebsite;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialWebsiteCreateSuccessActionCreator {
    (
        formData: Dtos.TrialWebsite,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialWebsiteCreateSuccessAction;
}

export interface ITrialWebsiteCreateFailureAction {
    type: "ACTION_TRIALWEBSITE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialWebsiteCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialWebsiteCreateFailureAction;
}

export interface ITrialWebsiteClearAction {
    type: "ACTION_TRIALWEBSITE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialWebsiteClearActionCreator {
    (propertiesToClear?: string[]): ITrialWebsiteClearAction;
}

export interface ITrialWebsiteFilterActionCreator {
    (formFilter: IFormFilter): ITrialWebsiteFilterAction;
}

export interface ITrialWebsiteFilterAction {
    type: "ACTION_TRIALWEBSITE_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialWebsiteSyncAction {
    type: "ACTION_TRIALWEBSITE_SYNC",
    trialId: number
}

export interface ITrialWebsiteSyncActionCreator {
    (trialId: number): ITrialWebsiteSyncAction
}

export interface ITrialWebsiteSyncSuccessAction {
    type: "ACTION_TRIALWEBSITE_SYNC_SUCCESS";
    formData: Dtos.TrialWebsite[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialWebsiteSyncSuccessActionCreator {
    (
        formData: Dtos.TrialWebsite[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialWebsiteSyncSuccessAction;
}

export interface ITrialWebsiteSyncFailureAction {
    type: "ACTION_TRIALWEBSITE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialWebsiteSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialWebsiteSyncFailureAction;
}

export type TrialWebsiteAction =
    ITrialWebsiteLoadByTrialIdAction |
    ITrialWebsiteLoadByIdAction |
    ITrialWebsiteLoadFailureAction |
    ITrialWebsiteLoadSuccessAction |
    ITrialWebsiteSaveAction |
    ITrialWebsiteSaveSuccessAction |
    ITrialWebsiteSaveFailureAction |
    ITrialWebsiteValidateAction |
    ITrialWebsiteValidateSuccessAction |
    ITrialWebsiteValidateFailureAction |
    ITrialWebsiteCreateAction |
    ITrialWebsiteCreateSuccessAction |
    ITrialWebsiteCreateFailureAction |
    ITrialWebsiteSyncAction |
    ITrialWebsiteSyncSuccessAction |
    ITrialWebsiteSyncFailureAction |
    ITrialWebsiteClearAction | 
    ITrialWebsiteFilterAction;
